import { render, staticRenderFns } from "./QuestionPost.vue?vue&type=template&id=d0cff444&scoped=true&"
import script from "./QuestionPost.vue?vue&type=script&lang=js&"
export * from "./QuestionPost.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPost.vue?vue&type=style&index=0&id=d0cff444&prod&lang=css&"
import style1 from "./QuestionPost.vue?vue&type=style&index=1&id=d0cff444&prod&scoped=true&lang=css&"
import style2 from "./QuestionPost.vue?vue&type=style&index=2&id=d0cff444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cff444",
  null
  
)

export default component.exports